
import React, { useState } from 'react';
import Sidebar from '../../Component/Profile/Profilesidebarnew.jsx';
import Profile from '../../Component/Profile/Profile.js';
import Wallet from '../../Component/Profile/Payment';
import Orders from '../../Component/Profile/Order.js';
import Favorites from '../../Component/Profile/Favorites';
import Notifications from '../../Component/Profile/Notifications';
import Support from "./Support";
import Settings from "./Settings";
import './Alliteams.css';

const App = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [activeTab, setActiveTab] = useState('Profile');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (window.innerWidth <= 768) {
      setIsMobileMenuOpen(false);
    }
  };

  const renderComponent = () => {
    switch(activeTab) {
      case 'Profile':
        return <Profile />;
      case 'Wallet':
        return <Wallet />;
      case 'Orders':
        return <Orders />;
      case 'Favorites':
        return <Favorites />;
      case 'Notifications':
        return <Notifications />;
      case 'Support':
        return <Support />;
      case 'Settings':
        return <Settings />;
      default:
        return <Profile />;
    }
  };

  return (
    <div className="app-container">
      {isMobileMenuOpen && <div className="app-mobile-overlay" onClick={() => setIsMobileMenuOpen(false)}></div>}
      
      <Sidebar 
        isOpen={isSidebarOpen} 
        activeTab={activeTab}
        onTabChange={handleTabChange}
        onToggle={toggleSidebar}
        isMobileOpen={isMobileMenuOpen}
      />

      <div className={`app-main-content ${!isSidebarOpen ? 'app-expanded' : ''}`}>
        <div className="app-mobile-header">
          <button className="app-hamburger-btn" onClick={toggleMobileMenu}>
            <span></span>
            <span></span>
            <span></span>
          </button>
          <div className="app-mobile-active-title">{activeTab}</div>
          <div className="app-mobile-placeholder"></div>
        </div>

        <div className="app-content-card">
          {renderComponent()}
        </div>
      </div>
    </div>
  );
};

export default App;





